export enum CalculationAgreementTypeEnum {
  PrivacyPolicyAgreement = 'dataAgreement',
  MarketingAgreement = 'marketingAgreement',
  PrivacyPolicyAgreementExtended = 'dataAgreementExtended',
  MarketingAgreementExtended = 'marketingAgreementExtended',
}
